function BviWidget() {
  const handleClick = (e) => {
    e.preventDefault();
    const panel = document.querySelector(".bvi-panel");
    if (panel) {
      if (panel.classList.contains("bvi-panel-hide")) {
        // Панель свёрнута — разворачиваем через bvi-кнопку, без повторной инициализации
        document.querySelector('[data-bvi="panel-show"]')?.click();
      }
      // Панель уже видима — ничего не делаем
      return;
    }
    // Панели нет — открываем
    document.getElementById("bvi-trigger")?.click();
  };

  return (
    <a
      href="#"
      style={{
        marginRight: 20,
        color: "rgb(0 128 198 / var(--tw-text-opacity, 1))",
      }}
      onClick={handleClick}
      aria-label="Версия для слабовидящих"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 18C20.2091 18 22 16.2091 22 14C22 11.7909 20.2091 10 18 10C15.7909 10 14 11.7909 14 14C14 16.2091 15.7909 18 18 18Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M6 18C8.20914 18 10 16.2091 10 14C10 11.7909 8.20914 10 6 10C3.79086 10 2 11.7909 2 14C2 16.2091 3.79086 18 6 18Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M14 14.214L13.344 13.98C12.4748 13.6698 11.5252 13.6698 10.656 13.98L10 14.214M2 14L2.763 8.605C2.878 7.341 2.936 6.709 3.306 6.242C3.676 5.775 4.278 5.574 5.482 5.172L6 5M22 14L21.237 8.605C21.122 7.341 21.065 6.709 20.695 6.242C20.325 5.775 19.722 5.574 18.518 5.172L18 5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </a>
  );
}

export default BviWidget;
